import { withOktaAuth } from '@okta/okta-react';
import { Component } from 'react'
import UserContext from '../../contexts/UserContext'
import api from '../../apis/api'
import { ErrorToast } from '../Toasters';
import { Card} from 'semantic-ui-react';

import UpdateFeedModal from './UpdateFeedModal';
import UpdateFeed from './UpdateFeed';
import AddUpdateModal from './AddUpdateModal';


export default withOktaAuth(class PortalUpdates extends Component {
    static contextType = UserContext
    state = {
        portalUpdates: [],
    }
    getPortalUpdates = () => {
        this._isUpdated = true
        api.get('/portalupdates').then(r => {
            this.setState({ portalUpdates: r.data })
        })
    }


    componentDidUpdate() {
        if (this._isUpdated === false) {
            this.getPortalUpdates()
        }
    }
    componentDidMount() {
        this._isUpdated = false
        if (this.props.authState) {
            this.getPortalUpdates()
        }
    }
    render() {
        return (
            <>
                <AddUpdateModal getPortalUpdates={this.getPortalUpdates}/>
                <Card.Group>
                    <UpdateFeed portalUpdates={this.state.portalUpdates.slice(0, 3)} getPortalUpdates={this.getPortalUpdates}/>
                    {this.state.portalUpdates.length > 3 ?
                        <UpdateFeedModal portalUpdates={this.state.portalUpdates} getPortalUpdates={this.getPortalUpdates} />
                        :
                        null}
                </Card.Group>
            </>
        )
    }
})
